<script setup>
import StatusPill from '@/Pages/Common/StatusPill.vue';

defineProps({
  pills: Array,
  title: String
});
</script>

<template>
  <div class="flex items-center gap-2 md:gap-4">
    <div class="font-bold">{{ title }}</div>
    <div class="flex flex-wrap items-center gap-1 md:gap-2">
      <slot />
      <StatusPill
        v-for="(tag, index) in pills"
        :key="index"
        :action-type="tag.actionType"
      >
        {{ tag.pill }}
      </StatusPill>
      <slot name="after" />
    </div>
  </div>
</template>
